export const LIST_POPULAR_MOVIES = 'LIST_POPULAR_MOVIES';
export const LIST_UPCOMING_MOVIES = 'LIST_UPCOMING_MOVIES';
export const LIST_MOVIES_BY_GENRE = 'LIST_MOVIES_BY_GENRE';
export const LIST_GENRES_FROM_API = 'LIST_GENRES_FROM_API';
export const GET_MOVIES_BY_GENRE = 'GET_MOVIES_BY_GENRE';
export const LIST_GENRES = 'LIST_GENRES';
export const GET_GENRE_BY_ID = 'GET_GENRE_BY_ID';
export const LIST_MOVIES = 'LIST_MOVIES';
export const GET_MOVIE_INFO = 'GET_MOVIE_INFO';
export const GET_MOVIE_DETAILS = 'GET_MOVIE_DETAILS';
export const ADD_GENRE = 'ADD_GENRE';
